function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.766 8.364L0 20.64 3.248 24 15 11.738 26.752 24 30 20.64 18.234 8.364l.004-.004-.808-.835L15.01 5l-.01.01-.01-.01-2.42 2.525-.808.835.004.004z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "5",
  width: "30",
  height: "19"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.766 8.364L0 20.64 3.248 24 15 11.738 26.752 24 30 20.64 18.234 8.364l.004-.004-.808-.835L15.01 5l-.01.01-.01-.01-2.42 2.525-.808.835.004.004z",
  fill: "currentColor"
}))));